import { routerActions } from 'react-router-redux';
import { UserAuthWrapper } from 'redux-auth-wrapper';
import Loading from '../../components/Loading';

export default failureRedirectPath =>
  UserAuthWrapper({
    authSelector: state => state.get('auth').user,
    authenticatingSelector: state => state.get('auth').isFetching,
    LoadingComponent: Loading,
    redirectAction: routerActions.replace,
    wrapperDisplayName: 'AuthWrapper',
    failureRedirectPath,
  });



// WEBPACK FOOTER //
// ./src/containers/Auth/verifyUser.js